import fromAnyToString from 'utils/converters/fromAnyToString';
import withOptions from 'utils/functions/withOptions.util';
import asObject from 'utils/objects/asObject.util';

const determineActiveSelection = withOptions(({ element }) => {
  const { activeElement } = document;

  const el = asObject(element);
  const val = fromAnyToString(el.value);
  const isActive = activeElement === element;

  return { bgn: el.selectionStart, end: el.selectionEnd, len: val.length, isActiveElement: isActive };
});

export default determineActiveSelection;
